import styled from 'styled-components';

export const ContainerNeedHelp = styled.div`
  border-top: 1px solid #b1b3b3;
  margin-top: 24px;
  width: 100%;
  text-align: center;
  padding-top: 8px;

  .toggle-text {
    display: inline;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    line-height: 20px;
    color: ${({ tema }) => tema?.primaryColor};
    margin-top: 8px;

    letter-spacing: 0.06px;
    text-decoration-line: underline;
  }

  .container-need-help {
    border: 1px solid #b1b3b3;
    border-radius: 6px;
    width: 100%;
    margin-top: 24px;

    .header-need-help {
      box-sizing: border-box;
      padding: 16px;
      background-color: ${({ tema }) => tema?.primaryColor};
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      display: flex;
      justify-content: space-between;

      span {
        font-size: 18px;
        font-weight: 700;
        line-height: 28px;
        color: #fff;
      }
    }

    .body-need-help {
      padding: 24px 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-flow: row wrap;

      .contact-container {
        font-size: 16px;
        line-height: 24px;

        .phone {
          color: ${({ tema }) => tema?.primaryColor};
          font-weight: 700;
          margin-top: 8px;
          display: flex;
          align-items: center;
          gap: 8px;
        }
      }

      @media (max-width: 768px) {
        button {
          width: 100%;
          margin-top: 8px;
        }
      }
    }
  }
`;
